import React from 'react';
import { MenuFiltersProps } from './types';
import { FilterBody } from './menu-filter.styles';
import { useProductTypesListSharedQuery } from '@entities/product/libs/hooks/use-product-types-list-shared-query/use-product-types-list-shared-query';
import { DEFAULT_PRODUCT_TYPES_LIST_PARAMETERS } from '@entities/product/config/store-constants';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { Filter } from '@shared/ui/filter/filter';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { Typography } from '@shared/ui/typography/typography';
import { Switch } from '@vtbhome/juicyfront';
import { Checkbox } from '@shared/ui/checkbox/checkbox';

export const MenuFilters: React.FC<MenuFiltersProps> = ({ parameters, setParameters }) => {
    const [, getProductTypesResult] = useProductTypesListSharedQuery({
        ...DEFAULT_PRODUCT_TYPES_LIST_PARAMETERS,
        take: null,
    });
    const productTypesError = getQueryError(getProductTypesResult);
    const productTypes = getProductTypesResult.data;

    const handleChangeOnlyFree = (isActive: boolean) => {
        if (!setParameters || !parameters) {
            return;
        }
        setParameters({ ...parameters, onlyFree: isActive });
    };

    const handleChangeProductType = (productTypeId: number) => () => {
        if (!setParameters || !parameters) {
            return;
        }
        const checkedProductTypes = parameters.types ? [...parameters.types] : [];
        const isChecked = checkedProductTypes.includes(productTypeId);
        const newCheckedList = isChecked
            ? checkedProductTypes?.filter((id) => id !== productTypeId)
            : checkedProductTypes;
        if (!isChecked) {
            newCheckedList.push(productTypeId);
        }
        setParameters({ ...parameters, types: newCheckedList });
    };

    const handleResetFilters = () => {
        if (!setParameters || !parameters) {
            return;
        }
        setParameters({ ...parameters, onlyFree: false, types: [] });
    };

    return (
        <Filter onResetAllFilters={handleResetFilters}>
            <FilterBody>
                <Switch
                    value={Boolean(parameters?.onlyFree)}
                    label='Отображать только бесплатные'
                    onChange={handleChangeOnlyFree}
                />
                <Typography size='body2_short' color='neutral_50'>
                    Тип продукта
                </Typography>
                <NetworkStateNew
                    size='s'
                    isLoading={
                        getProductTypesResult.isFetching ||
                        getProductTypesResult.isLoading ||
                        getProductTypesResult.isUninitialized
                    }
                    isError={Boolean(productTypesError)}
                    isInitialized={Boolean(productTypes)}
                    isFiltered={false}
                    hasData={Boolean(productTypes?.items.length)}
                    errorProps={{
                        title: 'Ошибка загрузки типов продуктов',
                        description: productTypesError?.message,
                    }}>
                    {productTypes?.items.map((productType) => {
                        return (
                            <Checkbox
                                key={productType.id}
                                label={productType.name}
                                checked={Boolean(parameters?.types?.includes(productType.id))}
                                onChange={handleChangeProductType(productType.id)}
                            />
                        );
                    })}
                </NetworkStateNew>
            </FilterBody>
        </Filter>
    );
};
